import React from 'react';
import styles from './skill-level.module.css';
import { Chip } from '../../chips';
import { colourString } from '../../../library';
import classNames from 'classnames';
import { generateOpacity } from './skill-level.helpers';
function Dots(_a) {
    var level = _a.level, minLevel = _a.minLevel, maxLevel = _a.maxLevel, dotColour = _a.dotColour;
    var dots = [];
    for (var i = minLevel; i <= maxLevel; i++) {
        dots.push(i);
    }
    return (React.createElement("div", { className: styles.dots }, dots.map(function (dot, index) {
        var opacity = generateOpacity(index, level, maxLevel);
        return (React.createElement(React.Fragment, { key: dot }, dot <= level ? (React.createElement("div", { className: styles.filledDot, style: { background: colourString(dotColour), opacity: opacity } })) : (React.createElement("div", { className: styles.emptyDot }))));
    })));
}
export function SkillLevel(_a) {
    var level = _a.level, minLevel = _a.minLevel, maxLevel = _a.maxLevel, notAssessed = _a.notAssessed, _b = _a.dotColour, dotColour = _b === void 0 ? 'baby-blue' : _b, title = _a.title, _c = _a.titleColour, titleColour = _c === void 0 ? 'text_1' : _c, _d = _a.labelColour, labelColour = _d === void 0 ? 'text' : _d;
    return (React.createElement("div", { className: classNames('KPLR_SkillLevel', styles.container) },
        !!title && (React.createElement("h6", { className: "caption2", style: { color: colourString(titleColour) } }, title)),
        notAssessed ? (React.createElement("div", { className: styles.chip },
            React.createElement(Chip, { label: "Not assessed", variant: "tiny" }))) : (React.createElement("div", { className: styles.content },
            React.createElement("h5", { className: "caption1", style: { color: colourString(labelColour), textWrap: 'nowrap' } }, "Level ".concat(level > maxLevel ? maxLevel : level)),
            React.createElement(Dots, { level: level, minLevel: minLevel, maxLevel: maxLevel, dotColour: dotColour })))));
}
export default SkillLevel;
